<label class="toggle">
    <input class="toggle-checkbox" type="checkbox" [(ngModel)]="isChecked" (change)="onToggleChanged($event)"/>
    <span class="toggle-switch"></span>
</label>